(function () {
    'use strict';

    angular.module("imApp").factory("prePaymentsService", ['$ihttp', function ($ihttp) {
        let service = {
            getPrePaymentSum: function (parms) {
                return $ihttp.post({
                    method: 468,
                    parameters: parms || {}
                });
            },
            listPrePayments: function (parms) {
                return $ihttp.post({
                    method: 442,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
